import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';
import { getAccountSettings } from '../Settings';
import { default as AuthManager } from '../../core/authManager';

// ACTION CREATORS
export const setUserData = (payload = null) => ({
  type: ACTION.AUTH_SUCCESS,
  payload,
});
export const authBase = () => ({ type: ACTION.AUTH_BASE });
export const isAuthenticating = () => ({ type: ACTION.AUTHENTICATING });
export const authError = (error = null) => ({ type: ACTION.AUTH_ERROR, error });
export const authComplete = () => ({ type: ACTION.AUTH_COMPLETE });
export const setAPIToken = (token = null) => ({ type: ACTION.SET_API_TOKEN, token });
export const signOut = () => ({ type: ACTION.SIGN_OUT });
export const accessDenied = () => ({ type: ACTION.ACCESS_DENIED });

export const verifyToken = (token, cookies) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(setAPIToken(token));
    apiService.verifyToken(token)
    .then(response => {
      dispatch(setUserData(response));
      resolve(response);
    })
    .catch(error => {
      cookies.remove('APIToken');
      dispatch(authBase());
      reject(error);
    });
  });
}

export const updateAccount = (uid, data) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const authState = getState().authState;
    apiService.updateAccount(uid, data)
    .then(response => {
      let userData = Object.assign(authState.userData, response);
      dispatch(setUserData(userData));
      resolve(userData);
    })
    .catch(error => {
      console.log(error);
      reject(error);
    });
  });
}

export const exchangeCode = (code, code_verifier, cookies) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(isAuthenticating());
    AuthManager.exchangeCode(code, code_verifier)
      .then((response) => {
        // only trainers are allowed here
        if (response.trainer_relationship && response.trainer_relationship === "trainer") {
          cookies.set('APIToken', response.token, { path: '/' });
          dispatch(setUserData(response));
          dispatch(getAccountSettings());
        } else {
          dispatch(accessDenied());
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch(
          authError(
            error && error.response ? error.response.data : error.message,
          ),
        );
        reject(error);
      });
  });
};

export const logout = (cookies) => (dispatch, getState) => {
  cookies.remove('APIToken');
  return new Promise((resolve, reject) => {
    const authState = getState().authState;
    const userToken = authState.userData.token;
    AuthManager.signOut(userToken)
      .then((response) => {
        dispatch(signOut());
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};
